import PropTypes from "prop-types"

import Button from "components/ui/button"
import Image from "components/ui/image"
import { cn } from "styles/utils"

export const CardProductImageContainer = ({
  className = "",
  outOfStock,
  ...props
}) => (
  <div
    className={cn(
      "relative h-full shrink-0",
      outOfStock &&
        "after:absolute after:left-0 after:top-0 after:h-full after:w-full after:bg-black after:opacity-10",
      className
    )}
    style={{
      "--base-width": "120px",
      "--desktop-width": "130px",
    }}
    {...props}
  />
)
CardProductImageContainer.propTypes = {
  className: PropTypes.string,
  outOfStock: PropTypes.bool,
}

export const CardProductImage = ({ className = "", ...props }) => (
  <Image
    className={cn("w-(--base-width) desktop:w-(--desktop-width)", className)}
    height="512"
    width="512"
    {...props}
  />
)
CardProductImage.propTypes = {
  className: PropTypes.string,
}

export const RemoveItem = ({ className = "", ...props }) => (
  <Button
    className={cn(
      "border-grey-65 text-grey-65 text-12 absolute right-0 top-0 aspect-square size-20 shrink-0 rounded-full border",
      className
    )}
    text
    variant="tertiary"
    {...props}
  />
)
RemoveItem.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
}

export const OutOfStockLabel = ({ className = "", ...props }) => (
  <div
    className={cn(
      "text-12 h-22 leading-22 z-1 absolute bottom-0 w-full bg-black text-center font-bold text-white",
      className
    )}
    {...props}
  />
)
OutOfStockLabel.propTypes = {
  className: PropTypes.string,
}

export const CardItem = ({ className = "", selected, ...props }) => (
  <Button
    className={cn(
      "focus:border-primary focus:outline-hidden basis-110 border-grey-20 block min-w-0 shrink-0 grow-0 rounded-lg border px-6 py-10 text-center",
      selected &&
        "after:content-(--checkmark-icon) border-primary after:size-22 after:scale-80 relative after:absolute after:-bottom-12 after:left-1/2 after:block after:-translate-x-1/2",
      className
    )}
    text
    {...props}
  />
)
CardItem.propTypes = {
  className: PropTypes.string,
  selected: PropTypes.bool,
}
